document.addEventListener("DOMContentLoaded", function() {
  const teaser = document.getElementById('hbdTeaser');
  if (!teaser) return;

  const targetUrl = "https://happybanjodude.com/products/hbd-pro-membership";
  let activeBtn = null;

  // 1. Create Nudge Box
  const nudge = document.createElement('div');
  nudge.className = 'hbd-nudge-box';
  nudge.style.display = 'none'; // Force initial hide
  nudge.innerHTML = `
    <button class="hbd-nudge-close" style="position:absolute; top:5px; right:10px; background:none; border:none; font-size:24px; cursor:pointer; color:#999;">&times;</button>
    <div style="font-size:14px; margin-bottom:15px; font-weight:600; line-height:1.4;">Interactive features (audio playback, looping, slow-mo) are Pro features.</div>
    <a href="${targetUrl}" class="hbd-nudge-btn">Upgrade to HBD Pro</a>
    <div style="font-size:10px; color:#999; margin-top:10px; cursor:pointer;" class="hbd-nudge-close">Close this message</div>
  `;
  document.body.appendChild(nudge);

  const positionNudge = () => {
    if (!activeBtn || nudge.style.display !== 'block') return;
    
    if (window.innerWidth > 768) {
      const rect = activeBtn.getBoundingClientRect();
      nudge.style.left = `${rect.left + (rect.width / 2) - (nudge.offsetWidth / 2)}px`;
      nudge.style.top = `${rect.top - nudge.offsetHeight - 15}px`;
      nudge.style.transform = 'none';
    } else {
      nudge.style.left = '50%';
      nudge.style.top = '50%';
      nudge.style.transform = 'translate(-50%, -50%)';
    }
  };

  const showNudge = (e) => {
    e.preventDefault();
    e.stopPropagation();
    activeBtn = e.currentTarget;
    nudge.style.display = 'block';
    positionNudge();
  };

  const hideNudge = () => { 
    nudge.style.display = 'none'; 
    activeBtn = null;
  };

  // 2. Listeners
  const interactiveElements = teaser.querySelectorAll('.hbd-play-btn, .hbd-pill');
  interactiveElements.forEach(el => el.addEventListener('click', showNudge));

  window.addEventListener('scroll', positionNudge);
  
  // Close triggers
  nudge.querySelectorAll('.hbd-nudge-close').forEach(el => {
    el.addEventListener('click', (e) => {
      e.stopPropagation();
      hideNudge();
    });
  });

  document.addEventListener('click', (e) => {
    if (!nudge.contains(e.target) && nudge.style.display === 'block') hideNudge();
  });

  // 3. Frame logic
  const nextSection = teaser.closest('.shopify-section').nextElementSibling;
  if (nextSection) {
    const imgEl = nextSection.querySelector('img');
    if (imgEl) {
      const container = imgEl.closest('.image-container') || imgEl.parentElement;
      container.classList.add('hbd-player-frame');
    }
  }
});
